module.exports = __webpack_public_path__ + "static/About Image 5-31256255907f30d5567e54f5bab2ec51.jpg";